<p>type-entretient-detail works!</p>
